export const environment = {
  production: true,
  googleApiKey: "AIzaSyD25wMsCjO5PIml6KC2QWL8rpHeZlN2fKE",
  backendUrl: "https://api.bancreach.com/api",
  imageUrl: "https://api.bancreach.com",
  socketUrl: "wss://api.bancreach.com/ws/chat/",
  linkPreviewKey: "c49776a3422741c25e5685cb8c5f01f6",
  landingUrl:'https://bancreach.com',
  firebaseConfig: {
    apiKey: "AIzaSyAXCH52EsRrclgFBB3YjqWxn_hVnyFJbf4",
    authDomain: "bancreach-d64c8.firebaseapp.com",
    projectId: "bancreach-d64c8",
    storageBucket: "bancreach-d64c8.appspot.com",
    messagingSenderId: "721874445055",
    appId: "1:721874445055:web:3e0d13c311f795ea3ea2ca",
    measurementId: "G-V69L3L95YK",
    vapidKey:"BOa-d0WU-5mH2BSoRDaSUwKz_YsSHSNZvaWJpME0lEYzpDCFwOWF3K-kETMZhyJyoHoIDK2OHM9dwutrfAJ3Mcg"
    },
    path: '/firebase-messaging-sw.js',
    scope: '/'
};





// export const environment = {
//   production: true,
//   backendUrl: "https://python.webdevelopmentsolution.net/api",
//   imageUrl: "https://python.webdevelopmentsolution.net",
//   socketUrl: "wss://python.webdevelopmentsolution.net/ws/chat/",
//   googleApiKey: "AIzaSyAXCH52EsRrclgFBB3YjqWxn_hVnyFJbf4",
//   linkPreviewKey: "c49776a3422741c25e5685cb8c5f01f6",
//   landingUrl:'https://appgrowthcompany.com', /// change the code just use the domain not full path
//   firebaseConfig: {
//     apiKey: "AIzaSyAXCH52EsRrclgFBB3YjqWxn_hVnyFJbf4",
//     authDomain: "bancreach-d64c8.firebaseapp.com",
//     projectId: "bancreach-d64c8",
//     storageBucket: "bancreach-d64c8.appspot.com",
//     messagingSenderId: "721874445055",
//     appId: "1:721874445055:web:3e0d13c311f795ea3ea2ca",
//     measurementId: "G-V69L3L95YK",
//     vapidKey:"BOa-d0WU-5mH2BSoRDaSUwKz_YsSHSNZvaWJpME0lEYzpDCFwOWF3K-kETMZhyJyoHoIDK2OHM9dwutrfAJ3Mcg"
//     },
//   path: '/bancreach/web/firebase-messaging-sw.js',
//   scope: '/bancreach/web/'
// };
